var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Page } from "../../lib/page-component";
import "../../components/header";
import "../../components/leftMenu";
import page from 'page';
import KnockoutModel from "../../lib/knockout_model";
import "../../components/paging";
import * as authorization from "../../lib/authorization";
import * as ajax from "../../app-lib/ajax_proxy";
import './addTips.css';
import '../../lib/knockout_datePicker';
import "../../components/tree";
import '../../lib/knockout_fileUpload';
var addTips = /** @class */ (function (_super) {
    __extends(addTips, _super);
    function addTips(root) {
        var _this = _super.call(this, "", root, {}) || this;
        _this.treeData = [];
        _this.userId = ko.observable(authorization.getUserId()); //
        _this.leadurl = ko.observable('/api/logo/upload');
        _this.showAddImg = ko.observable(false); //管理图标
        _this.imgList = ko.observable([{ isSelect: ko.observable(true), imgUrl: ko.observable(''), imgDescription: ko.observable(''), imgId: ko.observable(''), dataId: '' }]); //图标管理数组
        _this.tipTime = ko.observable(); //提醒时间
        _this.tipContent = ko.observable(); //提醒内容
        _this.getUserUrl = ko.observable('/api/message/user');
        _this.isShowCheckbox = ko.observable(false); //显示复选框
        _this.recipient = ko.observable(); //收件人
        _this.recipientList = ko.observableArray([{ userId: '', userName: '' }]); //收件人列表
        _this.isHaveUser = ko.observable(false); //是否已存在该人员
        _this.userNameList = ko.observable([]); //人员id数组
        _this.keyWord = ko.observable(); //收件人搜索
        _this.showTree = ko.observable(true); //显示人员树
        _this.seachList = ko.observableArray([]); //搜索列表
        _this.logoId = ko.observable(); //提醒类型
        return _this;
    }
    // 获取图标列表
    addTips.prototype.getImgList = function () {
        var _this = this;
        ajax.get('/api/logo').then(function (d) {
            // console.log(d);
            _this.imgList([]);
            for (var n = 0; n < d.data.length; n++) {
                _this.imgList().push({ isSelect: ko.observable(false), imgUrl: ko.observable(''), imgDescription: ko.observable(''), imgId: ko.observable(''), dataId: '' });
            }
            _this.imgList(_this.imgList());
            // this.imgList([]);
            for (var i = 0; i < _this.imgList().length; i++) {
                // this.imgList().push({isedit:ko.observable(true),isAdd:ko.observable(true),imgUrl:ko.observable(''),imgDescription:ko.observable(''),imgId:ko.observable('')});
                _this.imgList()[i].isSelect(false);
                _this.imgList()[i].imgUrl(d.data[i].url);
                _this.imgList()[i].imgDescription(d.data[i].name);
                _this.imgList()[i].imgId(d.data[i].fileId);
                _this.imgList()[i].dataId = d.data[i].id;
            }
        });
    };
    // 选择图标
    addTips.prototype.selectImg = function (d, r) {
        for (var i = 0; i < this.imgList().length; i++) {
            if (this.imgList()[i].isSelect()) {
                this.imgList()[i].isSelect(false);
            }
        }
        if (this.imgList()[d].isSelect()) {
            this.imgList()[d].isSelect(false);
        }
        else {
            this.imgList()[d].isSelect(true);
            this.logoId(this.imgList()[d].dataId);
        }
    };
    // 用户判重
    addTips.prototype.userListDeduplication = function (arr, id) {
        var _this = this;
        this.userNameList([]);
        arr.forEach(function (item) {
            _this.userNameList().push(item.userId);
        });
        this.userNameList(this.userNameList());
        if (this.userNameList().indexOf(id) < 0) {
            this.isHaveUser(false);
        }
        else {
            this.isHaveUser(true);
        }
    };
    // 搜索人员
    addTips.prototype.serachUser = function () {
        var _this = this;
        this.showTree(false);
        ajax.get('/api/message/user', { content: this.keyWord() }).then(function (d) {
            _this.seachList(d.data);
        });
    };
    // 选择树收件人
    addTips.prototype.onOrgChange = function (org) {
        if (org.type == '1') {
            this.userListDeduplication(this.recipientList(), org.id);
            if (!this.isHaveUser()) {
                // console.log(this.recipientList());
                if (this.recipientList()[0].userId == '') {
                    this.recipientList()[0].userId = org.id;
                    this.recipientList()[0].userName = org.name;
                    this.recipient(org.name);
                }
                else {
                    this.recipientList().push({ userId: org.id, userName: org.name });
                    var str = void 0;
                    for (var i = 0; i < this.recipientList().length; i++) {
                        if (i < 1) {
                            str = this.recipientList()[i].userName;
                            // this.recipient()
                        }
                        else {
                            str = str + ';' + this.recipientList()[i].userName;
                        }
                    }
                    this.recipient(str);
                }
            }
        }
    };
    // 选择搜索收件人
    addTips.prototype.selectSerachUser = function (d, r) {
        // console.log(d, r);
        this.userListDeduplication(this.recipientList(), d.username);
        if (!this.isHaveUser()) {
            // console.log(this.recipientList());
            if (this.recipientList()[0].userId == '') {
                this.recipientList()[0].userId = d.username;
                this.recipientList()[0].userName = d.name;
                this.recipient(d.name);
            }
            else {
                this.recipientList().push({ userId: d.username, userName: d.name });
                var str = void 0;
                for (var i = 0; i < this.recipientList().length; i++) {
                    if (i < 1) {
                        str = this.recipientList()[i].userName;
                        // this.recipient()
                    }
                    else {
                        str = str + ';' + this.recipientList()[i].userName;
                    }
                }
                this.recipient(str);
            }
        }
    };
    // 搜索框监控
    addTips.prototype.noSerachKeyWord = function (d) {
        if (Number(this.keyWord().length) < 1 && d.keyCode == '8') {
            this.showTree(true);
        }
    };
    // 清空人员
    addTips.prototype.clearUserList = function () {
        this.recipientList([{ userId: '', userName: '' }]);
        this.recipient('');
    };
    // 发送提醒
    addTips.prototype.sendTips = function () {
        var tipTime = this.tipTime() + ':00';
        if (!this.recipient()) {
            return window.popBox.show('请选择收件人');
        }
        if (!this.logoId()) {
            return window.popBox.show('请选择提醒类型');
        }
        if (!this.tipTime()) {
            return window.popBox.show('请选择提醒时间');
        }
        if (!this.tipContent()) {
            return window.popBox.show('请填写提醒内容');
        }
        ajax.post('/api/message', {
            logoId: this.logoId(),
            userName: authorization.getUsername(),
            userId: authorization.getUserId(),
            content: this.tipContent(),
            alertTime: tipTime,
            users: this.recipientList()
        }).then(function (d) {
            // console.log(d);
            if (d.status == '0') {
                ko.postbox.publish('reshLeft', '1');
                window.popBox.show('提交成功').then(function (d) {
                    page('/home/tipsList');
                });
            }
        }).catch(function (res) {
            if (res.status == '2') {
                return window.popBox.show(res.message);
            }
        });
    };
    // 重置
    addTips.prototype.rest = function () {
        this.imgList([{ isSelect: ko.observable(true), imgUrl: ko.observable(''), imgDescription: ko.observable(''), imgId: ko.observable(''), dataId: '' }]);
        this.recipient(''); //收件人
        this.recipientList([{ userId: '', userName: '' }]); //收件人列表
        this.keyWord(''); //收件人搜索
        this.showTree(true); //显示人员树
        this.seachList([]); //搜索列表
        this.logoId(''); //提醒类型
        this.tipTime(''); //提醒时间
        this.tipContent(''); //提醒内容
    };
    return addTips;
}(KnockoutModel));
var DemoModel = /** @class */ (function (_super) {
    __extends(DemoModel, _super);
    function DemoModel() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DemoModel.prototype.init = function () {
        this.vm = new addTips(this.container.querySelector('.addTips'));
        this.vm.bind();
    };
    DemoModel.prototype.update = function (arg) {
        this.vm.rest();
        this.vm.getImgList();
        return Promise.resolve();
    };
    DemoModel.prototype.onInitComplete = function () {
    };
    return DemoModel;
}(Page));
export default DemoModel;
